import { useRef } from 'react';
import { TimelineScrollbarProps } from '../types';

export function TimelineScrollbar(props: TimelineScrollbarProps) {
  const { thumbLeftPercent, thumbWidthPercent, onThumbDragStart, onThumbDrag } =
    props;

  const trackRef = useRef<HTMLDivElement>(null);
  const isDragging = useRef(false);
  const dragStartX = useRef(0);
  const dragStartThumbLeft = useRef(0);

  const isFullWidth = thumbWidthPercent >= 100;

  const onMouseDown = (e: React.MouseEvent) => {
    if (isFullWidth) return;
    e.preventDefault();
    isDragging.current = true;
    dragStartX.current = e.clientX;
    dragStartThumbLeft.current = thumbLeftPercent;
    onThumbDragStart();

    const onMouseMove = (moveEvent: MouseEvent) => {
      if (!isDragging.current || !trackRef.current) return;
      const trackWidth = trackRef.current.getBoundingClientRect().width;
      const deltaX = moveEvent.clientX - dragStartX.current;
      const deltaPercent = (deltaX / trackWidth) * 100;
      const newLeft = Math.max(
        0,
        Math.min(
          100 - thumbWidthPercent,
          dragStartThumbLeft.current + deltaPercent
        )
      );
      onThumbDrag(newLeft);
    };

    const onMouseUp = () => {
      isDragging.current = false;
      window.removeEventListener('mousemove', onMouseMove);
      window.removeEventListener('mouseup', onMouseUp);
    };

    window.addEventListener('mousemove', onMouseMove);
    window.addEventListener('mouseup', onMouseUp);
  };

  return (
    <div
      ref={trackRef}
      className={`relative mt-1 h-2 w-full rounded-full ${
        isFullWidth ? '' : 'bg-onlight-bg-3 dark:bg-ondark-bg-3'
      }`}
    >
      {!isFullWidth && (
        <div
          className="absolute top-0 h-full cursor-grab rounded-full bg-gray-400 active:cursor-grabbing dark:bg-gray-500"
          style={{
            left: `${thumbLeftPercent}%`,
            width: `${thumbWidthPercent}%`,
          }}
          onMouseDown={onMouseDown}
        >
          <div className="pointer-events-none absolute left-1/2 top-1/2 flex -translate-x-1/2 -translate-y-1/2 items-center gap-[2px]">
            <span className="h-1 w-px rounded-full bg-gray-700 dark:bg-gray-200" />
            <span className="h-1 w-px rounded-full bg-gray-700 dark:bg-gray-200" />
            <span className="h-1 w-px rounded-full bg-gray-700 dark:bg-gray-200" />
          </div>
        </div>
      )}
    </div>
  );
}

export default TimelineScrollbar;
